<div class="summary__buttons">
  <ion-button (click)="prevPage()" *ngIf="!firstPage"> 
    <ion-icon name="chevron-back-outline"></ion-icon>
    Back
  </ion-button>

  <ion-button (click)="nextPage()" [class.disabled]="!valid">
    {{nextBtnText}}
    <ion-icon name="chevron-forward-outline"></ion-icon>
  </ion-button>
</div>